module.exports = __webpack_public_path__ + "img/tictactoe.5dfd6101.jpeg";